import React, {useCallback} from 'react';
import {TextField} from '@mui/material';
import {removeInitialSpecialChars} from '../../../../util/sanitizeUtil';
import {CheckInFieldProps} from '../interfaces';
import {CODE_INPUT_PROPS} from './keyboardInputProps';

/**
 * Chassis Number text field.
 * Strips spaces, uppercases, and sanitizes input on every keystroke.
 */
const ChassisNumberField: React.FC<CheckInFieldProps> = ({value, onValueChange, error, required}) => {
  const handleChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const sanitized = removeInitialSpecialChars(e.target.value.toUpperCase()).replace(/ /g, '');
    onValueChange('chassisNumber', sanitized);
  }, [onValueChange]);

  return (
    <TextField
      id="chassisNumber"
      name="chassisNumber"
      label="Chassis Number"
      value={value}
      onChange={handleChange}
      placeholder="Enter the chassis number"
      variant="standard"
      fullWidth
      required={required}
      error={!!error}
      helperText={error}
      inputProps={{...CODE_INPUT_PROPS, 'aria-label': 'Chassis Number'}}
    />
  );
};

export default ChassisNumberField;

